import {
  AppState,
  ActionTypes,
  CLEAR_APP_ERROR,
  GET_COUNTERS,
  SET_APP_ERROR,
  SET_TOKEN,
  SET_GOOGLE_TOKEN,
  GET_CLIENTS,
  SET_CLIENTS,
  SET_CLIENT,
  UPDATE_CLIENT,
  LOG_OUT,
  DELETE_CLIENT,
  PAUSE_CLIENT,
  ACTIVATE_CLIENT,
} from './types'
import { LocalStorage } from '../utils/localStorage'

const initialState: AppState = {
  clients: [],
  googleAccount: LocalStorage.getGoogleAccount(),
  googleToken: LocalStorage.getGoogleToken(),
  isGoogleLoggedIn: false,
  token: '',
  isLoading: false,
  isClientsLoading: true,
  appError: undefined,
}

export function appReducer(
  state = initialState,
  action: ActionTypes,
): AppState {
  switch (action.type) {
    case DELETE_CLIENT:
      return {
        ...state,
        isLoading: false,
        clients: state.clients.filter((c) => c._id !== action.payload.id),
      }
    case PAUSE_CLIENT:
      return {
        ...state,
        isLoading: false,
        clients: state.clients.map((c) => {
          if (c._id === action.payload.id) {
            return {
              ...c,
              stopped: true,
            }
          }
          return c
        }),
      }
    case ACTIVATE_CLIENT:
      return {
        ...state,
        isLoading: false,
        clients: state.clients.map((c) => {
          if (c._id === action.payload.id) {
            return {
              ...c,
              stopped: false,
            }
          }
          return c
        }),
      }
    case LOG_OUT:
      return {
        ...state,
        googleAccount: null,
        googleToken: null,
        isGoogleLoggedIn: false,
        isLoading: false,
      }
    case SET_TOKEN:
      return {
        ...state,
        token: action.payload,
      }
    case SET_GOOGLE_TOKEN:
      return {
        ...state,
        googleToken: action.payload,
      }
    case GET_CLIENTS:
      return {
        ...state,
        isClientsLoading: true,
      }

    case SET_CLIENTS:
      return {
        ...state,
        isClientsLoading: false,
        clients: action.payload,
      }
    case SET_CLIENT:
      return {
        ...state,
        isLoading: false,
        clients: [action.payload, ...state.clients],
      }
    case UPDATE_CLIENT:
      return {
        ...state,
        isLoading: false,
        clients: state.clients.map((c) => {
          if (c._id === action.payload.id) {
            return {
              ...c,
              ...action.payload,
              limits: {
                ...c.limits,
                ...action.payload.limits,
                success: {
                  ...c.limits?.success,
                  ...action.payload.limits?.success,
                },
              },
            }
          }
          return c
        }),
      }
    case GET_COUNTERS:
      return {
        ...state,
        isLoading: true,
      }
    // case SET_COUNTERS:
    //   return {
    //     ...state,
    //     counters: action.payload,
    //     isLoading: false,
    //   }
    case SET_APP_ERROR:
      return {
        ...state,
        appError: action.payload,
        isLoading: false,
      }
    case CLEAR_APP_ERROR:
      return {
        ...state,
        appError: undefined,
      }
    default:
      return state
  }
}
